<template>
<m-pageframe
    title="{organization-label}: Edit Tag"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px; padding-top: 15px;"
    v-if="tag != null"
>
    <v-text-field
        :value="tag.rc_tag_id"
        label="Tag Id"
        readonly
        disabled
        autocomplete="off"
    />

    <v-text-field
        label="Label"
        v-model="tag.label"
        v-on:input="update"
        autocomplete="off"
    />

    <v-chip
        :color="tag.color"
        style="margin-bottom: 15px"
    >
        {{tag.label}}
    </v-chip>

    <span
        style="margin-left: 15px; position: relative; top: -5px"
    >
        To change the tag's color <a v-on:click="onClickChangeTagColor">click here.</a>
    </span>

    <v-textarea
        label="Notes"
        v-model="tag.notes"
        v-on:input="update"
        auto-grow
        rows="1"
    />

    <m-tag-color-picker-dialog
        ref="color-picker"
        v-on:update-tag="onChangeTagColor"
    />

    <template v-for="(item, index) in $rc.enumChoices('red_chirp_tag_applies_to',false)">
        <!-- Regular checkboxes for non-admin features -->
        <v-checkbox
            v-if="!item.system_admins_only"
            :key="index"
            v-on:change="doUpdate"
            :label="item.text"
            v-model="tag.applies_to"
            :value="item.value"
            style="margin-bottom: -25px"
        />

        <!-- Restricted fields for admin-only features -->
        <m-restricted-field
            v-if="item.system_admins_only && $rc.$state.isAuthActorSystemAdmin()"
            :key="'restricted-'+index"
            position="checkbox"
        >
            <v-checkbox
                v-on:change="doUpdate"
                :label="item.text"
                v-model="tag.applies_to"
                :value="item.value"
                style="margin-bottom: -25px"
            />
        </m-restricted-field>
    </template>

    <v-checkbox
        label="Archived"
        v-model="tag.is_archived"
        v-on:change="doUpdate"
    />


</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            tag: null,
        }
    },

    mounted () {
        this.fetch();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        doUpdate()
        {
            this.$rc.rest(
                'PUT: /api/v1/rc-tags',

                this.tag,

                (data) => {
                },

                () => {

                    this.$rc.alert('Error','Unable to save changes to tag');
                },
            );
        },

        fetch() {
            this.$rc.showSpinner();

            this.$rc.rest(
                'LIST: /api/v1/rc-tags',

                {
                    'rc_tag_id': this.$route.params.rc_tag_id,
                },

                (data) => {
                    this.$rc.hideSpinner();

                    if ( data.results.length == 0 )
                    {
                        this.$rc.alert('Error','Unable to complete get tag');
                        return;
                    }

                    this.tag = data.results[0];
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete get tag');
                },
            );
        },

        onClickChangeTagColor()
        {
            this.$refs['color-picker'].showDialog(this.tag);
        },

        onChangeTagColor(new_tag)
        {
            this.tag.color = new_tag.color;
            this.doUpdate();
        }
    },
}
</script>

<style lang="scss" scoped>
</style>